import { Avatar, Flex, Text } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { formatBlocoQuadra } from "infra/helpers/formatBlocoQuadra";
import moment from "moment";
import { UnidadeParticipanteItem } from "features/assembleia/typings";

interface CardUnidadeParticipanteProps {
  unidadeParticipante: UnidadeParticipanteItem;
  bordered?: boolean;
  textCreatedAt?: string;
}

function CardUnidadeParticipante({
  unidadeParticipante,
  bordered,
  textCreatedAt = "lida",
}: CardUnidadeParticipanteProps) {
  return (
    <Flex
      borderBottomWidth={bordered ? 1 : 0}
      borderBottomColor={colors.black300}
      p={4}
      alignItems="center"
    >
      <Avatar
        name={unidadeParticipante.proprietario}
        src={unidadeParticipante.imagemUrl || undefined}
        w="45px"
        h="45px"
      />

      <Flex flexDir="column" ml={4}>
        <Text color={colors.black} fontWeight="bold">
          {unidadeParticipante.proprietario}
        </Text>

        {unidadeParticipante.unidade ? (
          <Text color={colors.black600}>
            {formatBlocoQuadra(
              unidadeParticipante.unidade?.numero,
              unidadeParticipante.unidade?.blocoQuadra
            )}
          </Text>
        ) : null}
      </Flex>

      {unidadeParticipante.createdAt ? (
        <Text ml="auto" color={colors.black600}>
          {textCreatedAt}{" "}
          {moment(unidadeParticipante.createdAt).format("DD/MM/YYYY")} às{" "}
          {moment(unidadeParticipante.createdAt).format("HH:mm")}
        </Text>
      ) : null}
    </Flex>
  );
}

export default CardUnidadeParticipante;
